import { useContext } from 'react';
import { DashboardContext } from '../../../contexts/states/DashboardState';
import { InputForm } from '../../Layouts/dashboard layouts/InputForm';

export const SettingsPage = () => {
  const { currentPrices } = useContext(DashboardContext);

  const openAccordion = (e) => {
    const list = e.target.parentElement.parentElement.parentElement;
    const accordion = list.querySelector('.settings-accordion');

    if (accordion.classList.contains('opened')) {
      accordion.classList.remove('opened');
      list.style.maxHeight = '200px';
    } else {
      accordion.classList.add('opened');
      list.style.maxHeight = '40px';
    }
  };

  return (
    <div className='main list'>
      <header className='desktop'>
        <h2>Settings</h2>
      </header>

      <ul className='settings-list'>
        <h4>Admin</h4>
        <li>
          <div className='setting'>
            <p className='title'>Password</p>
            <div className='current-state'>
              <p>Change Password</p>
              <i className='fas fa-edit' onClick={openAccordion}></i>
            </div>
          </div>
          <div className='settings-accordion'>
            <InputForm
              type='password'
              id='password'
              placeholder='Enter old password'
            />
          </div>
        </li>
        <h4 className='last'>Car Prices</h4>
        <li>
          <div className='setting'>
            <p className='title'>Luxury Price</p>
            <div className='current-state'>
              <p>&#8358;{currentPrices.luxury}</p>
              <i className='fas fa-edit' onClick={openAccordion}></i>
            </div>
          </div>
          <div className='settings-accordion'>
            <InputForm
              type='text'
              id='luxury'
              placeholder={currentPrices.luxury}
            />
          </div>
        </li>
        <li>
          <div className='setting'>
            <p className='title'>Premium Price</p>
            <div className='current-state'>
              <p>&#8358;{currentPrices.premium}</p>
              <i className='fas fa-edit' onClick={openAccordion}></i>
            </div>
          </div>
          <div className='settings-accordion'>
            <InputForm
              type='text'
              id='premium'
              placeholder={currentPrices.premium}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};
